import axios from 'axios'
import router from '../router/index.js'
import store from '../store'
import ElementUi from 'element-ui'
var root = process.env.API_ROOT;
// 添加请求request拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {

    if (localStorage.getItem('parkToken')) {
      config.headers.Token = localStorage.getItem('parkToken');
      // config.cancelToken = source.token; // 全局添加cancelToken
    }
    //请求之前重新拼装url
    config.url = root + config.url;
    return config;
  },
  error => {
    return Promise.reject(error);
  });

//添加 response 拦截器
axios.interceptors.response.use(
  response => {
    //console.log(Vue.prototype.$config);
    //判断token失效
    if (response.data.code == -10) {
      // source.cancel(); // 取消其他正在进行的请求
      localStorage.removeItem("parkToken");
      localStorage.removeItem("parkusername");
      localStorage.removeItem("parktype");
      localStorage.removeItem("parkmenuid");
      localStorage.removeItem("parkTokenTime");

      if (store.state.tokenStatus) {
        ElementUi.Message({
          message: '登录已过期,请重新登录~',
          type: "error"
        });
        // 修改tokenStatus状态，防止多次弹出
        store.commit('updateTokenStatus', false)
      }
      router.replace({
        path: '/' //登录成功后跳入浏览的当前页面
      })
    }
    return response;
  },
  error => {
    if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
      return new Promise(() => {});
    } else {
      return Promise.reject(error);
    }
  });

  export default axios



// WEBPACK FOOTER //
// ./src/api/http.js